import styled from "@emotion/styled";
import { Typography, TypographyProps } from "@kaltura/ds-react-components";
import { TruncatedLine } from "../../truncate/TruncatedLine";
import { useMediaQuery } from "@kaltura/mediaspace-shared-utils";

interface RowItemProps extends Omit<TypographyProps, "variant"> {
    /**
     * true for a primary (black) label, false for a secondary (gray) label
     */
    isMain?: boolean;
    /**
     * Truncate the label if it extends 1 text line
     * (by default, the text will wrap)
     */
    truncate?: boolean;
}

/**
 * One label inside asset's row.
 */
export const RowItem = ({ children, isMain, truncate, ...props }: RowItemProps) => {
    const isMobile = useMediaQuery((theme) => theme.breakpoints.down("sm"));

    return (
        <StyledTypography
            variant={isMain ? (isMobile ? "body2Highlight" : "body1Highlight") : "body2"}
            component={"div"}
            isMain={isMain}
            truncate={truncate}
            {...props}
        >
            {truncate ? <TruncatedLine>{children}</TruncatedLine> : children}
        </StyledTypography>
    );
};

const StyledTypography = styled(
    Typography,
    { shouldForwardProp: (propName) => propName !== "isMain" && propName !== "truncate" }
)<{ isMain?: boolean; truncate?: boolean }>(({ theme, isMain, truncate }) => ({
    color: isMain ? theme.kaltura.palette.tone1 : theme.kaltura.palette.tone2,
    minWidth: truncate ? 0 : undefined,
}));
